import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const Checklists = lazy(() => import('../../../../pages/Checklists/Checklists'));

export const Route = createFileRoute('/$lang/_authenticated/checklists')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <Checklists />
    </Suspense>
  ),
});
